import {FaEye} from "react-icons/fa"
import {viewLogOperation} from "../../classes/functions";

export default function ListLog({listItems, setViewLog, setModalViewLog}) {
    function openInfoModal(index) {
        setViewLog([]);
        setViewLog(listItems[index]);
        setModalViewLog(true);
    }

    return (
        <div className="body-modal">
            {listItems.length > 0 && <div>
                <div className="divGroup">
                    <h2>Histórico</h2>
                </div>
                <div className="container">
                    <table>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Usuário</th>
                            <th>Data</th>
                            <th>Hora</th>
                            <th>Operação</th>
                            <th>Status</th>
                            <th scope="col" className='collumOption'>Opções</th>
                        </tr>
                        </thead>
                        <tbody>
                        {listItems.map((item, index) => {
                            return (
                                <tr>
                                    <td>{index + 1}</td>
                                    <td>{item.user}</td>
                                    <td>{item.data}</td>
                                    <td>{item.hora}</td>
                                    <td>{viewLogOperation(item.operacao)}</td>
                                    <td>{item.status}</td>
                                    <td data-label="Opções">
                                        <FaEye color="#000" size={19} onClick={() => openInfoModal(index)}/>
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                </div>
            </div>}
        </div>
    )
}